var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronLeftEnabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3928 19.9997C15.603 20.0009 15.8114 19.9606 16.0061 19.8812C16.2007 19.8017 16.3777 19.6845 16.527 19.5365C16.6767 19.388 16.7956 19.2113 16.8767 19.0166C16.9578 18.8219 16.9995 18.6131 16.9995 18.4023C16.9995 18.1914 16.9578 17.9826 16.8767 17.7879C16.7956 17.5932 16.6767 17.4166 16.527 17.268L11.2393 12.0124L16.3193 6.72472C16.6168 6.42542 16.7838 6.02053 16.7838 5.5985C16.7838 5.17647 16.6168 4.77159 16.3193 4.47229C16.1708 4.32256 15.9941 4.20371 15.7995 4.12261C15.6048 4.04151 15.396 3.99976 15.1851 3.99976C14.9742 3.99976 14.7654 4.04151 14.5708 4.12261C14.3761 4.20371 14.1994 4.32256 14.0509 4.47229L7.88465 10.8622C7.59195 11.1608 7.428 11.5623 7.428 11.9804C7.428 12.3986 7.59195 12.8 7.88465 13.0986L14.2745 19.4885C14.4179 19.6434 14.5906 19.7683 14.7825 19.856C14.9744 19.9438 15.1819 19.9926 15.3928 19.9997Z",
    fill: "#4462EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeftEnabled);
export default __webpack_public_path__ + "static/media/chevron-left-enabled.2e0fdd83e540dc3a7f7546fb62ade3b1.svg";
export { ForwardRef as ReactComponent };